import { render, staticRenderFns } from "./SettingsLeftMenu.vue?vue&type=template&id=138a221c&scoped=true&"
import script from "./SettingsLeftMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLeftMenu.vue?vue&type=style&index=0&id=138a221c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a221c",
  null
  
)

export default component.exports